import {Inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {SystemInfo} from './info.interface';
import {HttpClient} from "@angular/common/http";
import {BASE_CLIENT, BaseClient} from "../client";

@Injectable({
  providedIn: 'root'
})
export class InfoService {

  private systemInfoOB: BehaviorSubject<SystemInfo> = new BehaviorSubject<SystemInfo>({});

  constructor(private http: HttpClient,
              @Inject(BASE_CLIENT) private baseclient: BaseClient) {
  }

  getSystemInfo(): Observable<SystemInfo> {
    return this.systemInfoOB.asObservable();
  }

  setSystemInfo(systemInfo: SystemInfo): void {
    this.systemInfoOB.next(systemInfo);
  }

  initSystemInfo(): Promise<any> {
    return new Promise<any>(resolve => {
      this.http.get(`${this.baseclient.gateway}/app-manager/project/info`).subscribe((response: any) => {
        this.setSystemInfo(response.data as any);
        resolve();
      });
    })
  }
}
